import { useForm, UseFormOptions } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers'
import { TContactInfoTypeSchema, ContactInfoTypeSchema } from '../schema'

/**
 * Props that we shouldn't overwrite
 */
type TOmittedProps = 'mode' | 'resolver'

interface IUseContactInfoFormProps
  extends Omit<UseFormOptions<TContactInfoTypeSchema>, TOmittedProps> {}

const getDefaultValues = (defaultValues = {}) => ({
  ...ContactInfoTypeSchema.cast(defaultValues),
})

const useContactInfoTypeForm = (props: IUseContactInfoFormProps = {}) => {
  const { defaultValues = {} } = props || {}

  return useForm<TContactInfoTypeSchema>({
    resolver: yupResolver(ContactInfoTypeSchema),
    mode: 'onChange',
    defaultValues: {
      ...getDefaultValues(defaultValues),
    },
    ...props,
  })
}

export default useContactInfoTypeForm
